import { createGlobalStyle } from 'styled-components'

export const AppGlobalStyles = createGlobalStyle`
  html, body, #root {
    height: 100%;
  }
  
  html {
    overflow-x: hidden;
  }
  
  body {
    overflow-x: hidden;
    position: relative;
  }
  
  #root {
    display: flex;
    flex-direction: column;
  }
`
